import { Monitor, Printer, Server, Smartphone, HardDrive, Package } from "lucide-react";

export const categoryIcons = {
  "Computer": Monitor,
  "Drucker": Printer,
  "Monitor": Monitor,
  "Netzwerk": HardDrive,
  "Server": Server,
  "Software-Lizenz": Package,
  "Medizingerät": Package,
  "Telefon/VoIP": Smartphone,
  "Scanner": Printer,
  "Sonstiges": Package,
};

export const getExpiryStatus = (expiryDate) => {
  if (!expiryDate) return null;
  const today = new Date().toISOString().split('T')[0];
  const thirtyDaysLater = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  if (expiryDate < today) return "expired";
  if (expiryDate <= thirtyDaysLater) return "expiring";
  return "valid";
};

export const formatSerialDate = (dateStr) => {
  if (!dateStr) return "";
  try {
    return new Date(dateStr).toLocaleDateString('de-DE');
  } catch {
    return dateStr;
  }
};
